// @flow

export const faceIdNames = {
	storageSpace: 'rgs-face-id',
	storageParam: 'RGS_FACE_ID',
	credentialId: 'CREDENTIAL_ID',
	currentUser: 'CURRENT_USER',
};

export const faceIdStatus = {
	on: 'ENABLED',
	off: 'DISABLED',
};

export const faceIdError = {
	plainTryLater: 'Что-то пошло не так, попробуйте позже',
	extendedTryLater: 'Что-то пошло не так, попробуйте позже или войдите по Логину и Паролю',
};

export type PhoneLoginStatus = 'Success'
	| 'ConfirmedPhoneNotFound'
	| 'NoProfileBinding'
	| 'InvalidPersonType'
	| 'SmsQuotaExceeded'
	| 'Blocked'
	| 'OutOfAttempts'
	| 'DmsAdminUntrustedPerimeter'
	| 'InvalidCode';

export const phoneLoginErrorMessage = {
	blocked: 'Превышено количество неудачных попыток ввода пароля. Повторите вход позднее.',
	invalidCode: 'Код неверный. Получить повторно через',
	// eslint-disable-next-line max-len
	smsQuotaExceeded: 'Превышено количество попыток получения проверочного кода. Вы сможете получить новый код через',
	outOfAttempts: 'Вы сможете войти через',
	// eslint-disable-next-line max-len
	dmsAdminUntrustedPerimeter: 'Вход в раздел администратора договоров ДМС вне сети Росгосстрах запрещен. Используйте ваш рабочий ПК.',
};

export const VTB_AUTH_URL_STATUS = 'vtbIdAuthStatus';

export const TIMER_URL_PARAM = 'tryAfterSeconds';

export type BankAuthStatus = 'Success'
	| 'Fail'
	| 'ValidationErrors'
	| 'PersonNotFound'
	| 'MobilePhoneMismatch'
	| 'DmsAdminUntrustedPerimeter'
	| 'TemporaryBanned'
	| 'VtbIdInteropFailure';

export const bankAuthErrorMessage = {
	// eslint-disable-next-line max-len
	PersonNotFound: ['Полис ДМС не найден.', 'Попробуйте зарегистрироваться в Личном кабинете или обратитесь в поддержку.'],
	// eslint-disable-next-line max-len
	MobilePhoneMismatch: ['Профиль с таким номером телефона не найден.', 'Попробуйте войти другим способом или обратитесь в поддержку.'],
	TemporaryBanned: ['Учетная запись временно заблокирована.', 'Попробуйте войти через'],
	VtbIdInteropFailure: 'Сервис ВТБ не отвечает. Попробуйте позднее или войдите другим способом.',
	// eslint-disable-next-line max-len
	DmsAdminUntrustedPerimeter: 'Вход в раздел администратора договоров ДМС вне сети Росгосстрах запрещен. Используйте ваш рабочий ПК.',
	Default: 'Возникла техническая ошибка. Попробуйте позднее или войдите другим способом.',
};
